import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState, useCallback } from "react";
import as from '../../../assets/popup/annual sales.png';
import Deliver from '../../../assets/popup/Deliver.png';
import bill from '../../../assets/popup/to bill.png';
import customer from '../../../assets/popup/customer.png';
import Header from "../../../Components/Header";
import Footer from "../../../Components/Footer";
import GetIcon from "../../../utils/Icon";
import CartFilterPopup from "../../../utils/Dashboard/Cart_Filter_Popup";
import { Active_Customer_Count_Payload, Annual_Sales_Count_Payload, createFilterState, Sales_Order_to_Bill_Count_Payload, Sales_Orders_to_Deliver_Count_Payload } from "./utils/DashboardData";
import ReactBarChart from "../../../utils/Dashboard/Chart/BarChart";
import { formatIndianPrice } from "../../../utils/formatIndianPrice";
import ReactLineChart from "../../../utils/Dashboard/Chart/LineChart";
import ReactDonutChart from "../../../utils/Dashboard/Chart/DonutChart";
import ChartFilterPopup from "../../../utils/Dashboard/Chart_Filter_Popup";
import { useGetSelectedCompanyQuery } from "../../../store/api/companyapi";
import { usePostDashboardChartMutation, usePostDashboardCountMutation, usePostDashboardPercentageCountMutation } from "../../../store/api/dashboard";
import Tabs from "../../../Components/Tabs";
import { Helmet } from "react-helmet";


const Dashboard = () => {
  // API hooks
  const [ChartDataApi] = usePostDashboardChartMutation();
  const [CountApi] = usePostDashboardCountMutation();
  const [CountPercentageApi] = usePostDashboardPercentageCountMutation();
  const { data } = useGetSelectedCompanyQuery();
  const selectedComapny = data?.message?.data?.company.split(' - ')[0];

  // UI state
  const [showpopup, setShowpopup] = useState(false);
  const [showChartPopup, setShowChartPopup] = useState(false);
  const [currentChartType, setCurrentChartType] = useState(null);
  const [currentFilterType, setCurrentFilterType] = useState(null);

  // Chart State
  const [sales_order_trends, setsales_order_trends] = useState({});
  const [delivery_note_trends, setdelivery_note_trends] = useState({});
  const [sales_order_analysis, setsales_order_analysis] = useState({});
  const [item_wise_annual_sales, setitem_wise_annual_sales] = useState({});

  // Count State 
  const initialCountState = { count: 0, percentage: 0 };
  const [AnnualSalesCount, setAnnualSalesCount] = useState(initialCountState);
  const [ActiveCustomersCount, setActiveCustomersCount] = useState(initialCountState);
  const [SalesOrderstoBillCount, setSalesOrderstoBillCount] = useState(initialCountState);
  const [SalesOrderstoDeliverCount, setSalesOrderstoDeliverCount] = useState(initialCountState);

  // Filter States 
  const [Annual_Sales_Filters, setAnnual_Sales_Filters] = useState(createFilterState('Monthly'));
  const [Active_Customers_Filters, setActive_Customers_Filters] = useState(createFilterState('Monthly'));
  const [Sales_Order_to_Bill_Filters, setSales_Order_to_Bill_Filters] = useState(createFilterState('Weekly', { statusFilters: [] }));
  const [Sales_Order_to_Deliver_Filters, setSales_Order_to_Deliver_Filters] = useState(createFilterState('Weekly', { statusFilters: [] }));
  const [SalesOrderTrendsFilters, setSalesOrderTrendsFilters] = useState({period: "Monthly",based_on: "Item",fiscal_year: "2025-2026",company: selectedComapny});
  const [DeliveryNoteTrendsFilters, setDeliveryNoteTrendsFilters] = useState({period: "Yearly",based_on: "Customer",fiscal_year: "2025-2026",company: selectedComapny});
  const [SalesOrderAnalysisFilters, setSalesOrderAnalysisFilters] = useState({from_date: "", to_date: "",status: [], company: selectedComapny});
  const [ItemWiseAnnualSalesFilters, setItemWiseAnnualSalesFilters] = useState({from_date: "",to_date: "",company: selectedComapny});

  // Helper functions
  const getCurrentChartFilters = useCallback(() => {
    const chartFilters = {
      "Sales_Order_Trends": SalesOrderTrendsFilters,
      "Delivery_Note_Trends": DeliveryNoteTrendsFilters,
      "Sales_Order_Analysis": SalesOrderAnalysisFilters,
      "Item_Wise_Annual_Sales": ItemWiseAnnualSalesFilters
    };
    return chartFilters[currentChartType] || {};
  }, [currentChartType, SalesOrderTrendsFilters, DeliveryNoteTrendsFilters, SalesOrderAnalysisFilters, ItemWiseAnnualSalesFilters]);

  const getCurrentFilters = useCallback(() => {
    const cardFilters = {
      'Annual_Sales': Annual_Sales_Filters,
      'Active_Customers': Active_Customers_Filters,
      'Sales_Order_to_Bill': Sales_Order_to_Bill_Filters,
      'Sales_Order_to_Deliver': Sales_Order_to_Deliver_Filters
    };
    return cardFilters[currentFilterType] || {};
  }, [currentFilterType, Annual_Sales_Filters, Active_Customers_Filters, Sales_Order_to_Bill_Filters, Sales_Order_to_Deliver_Filters]);

  const updateFilters = useCallback((filterType, newFilters) => {
    const filterSetters = {
      // Card Filters
      'Annual_Sales': setAnnual_Sales_Filters,
      'Active_Customers': setActive_Customers_Filters,
      'Sales_Order_to_Bill': setSales_Order_to_Bill_Filters,
      'Sales_Order_to_Deliver': setSales_Order_to_Deliver_Filters,
      // Chart Filters
      'Sales_Order_Trends': setSalesOrderTrendsFilters,
      'Delivery_Note_Trends': setDeliveryNoteTrendsFilters,
      'Sales_Order_Analysis': setSalesOrderAnalysisFilters,
      'Item_Wise_Annual_Sales': setItemWiseAnnualSalesFilters
    };

    filterSetters[filterType]?.((prev) => ({ ...prev, ...newFilters }));
  }, []);

  // API call functions
  const buildFilters = useCallback((doctype = "Sales Order", field = "modified", fromDate = "", toDate = "", statusFilters = []) => {
    const baseFilters = [];

    // Document type specific filters
    if (doctype === "Sales Order") {
      baseFilters.push(
        [doctype, "status", "in", statusFilters.length ? statusFilters : ["To Deliver", "To Deliver and Bill", null], false],
        [doctype, "company", "=", selectedComapny, false],
        [doctype, "docstatus", "=", "1", false]
      );
    } else if (doctype === "Customer") {
      baseFilters.push([doctype, "disabled", "=", "0", false]);
    }

    if (fromDate && toDate && field) {
      baseFilters.push([doctype, field, "Between", [fromDate, toDate], false]);
    }

    return baseFilters;
  }, [selectedComapny]);

  const Find_Annual_Sales_Count = useCallback(async (docData, filtersData, Count, percentage) => {
    if (!selectedComapny) return;
    
    try {
      const formData = new FormData();
      formData.append('doc', JSON.stringify(docData));
      formData.append('filters', JSON.stringify(filtersData));

      const response = await CountApi(formData);
      if (percentage) {
        await Find_Annual_Sales_Count_Percetage(docData, filtersData, response.data.message, Count);
      } else {
        Count(response.data.message);
      }
    } catch (error) {
      console.error("Error in Find_Annual_Sales_Count:", error);
    }
  }, [CountApi, selectedComapny]);

  const Find_Annual_Sales_Count_Percetage = useCallback(async (docData, filtersData, countvalue, Count) => {
    try {
      const formData = new FormData();
      formData.append('doc', JSON.stringify(docData));
      formData.append('filters', JSON.stringify(filtersData));
      formData.append('result', JSON.stringify(countvalue));

      const response = await CountPercentageApi(formData);
      Count({ count: countvalue, percentage: response.data.message });
    } catch (error) {
      console.error("Error in Find_Annual_Sales_Count_Percetage:", error);
    }
  }, [CountPercentageApi]);

  const ChartApi = useCallback(async (type, filter, setState) => {
    if (!selectedComapny) return;

    try {
      const finalFilters = {
        ...filter,
        company: selectedComapny,
        ...(type === "Sales Order Trends" && { based_on: "Item" })
      };

      const formData = new FormData();
      formData.append("report_name", type);
      formData.append("filters", JSON.stringify(finalFilters));
      formData.append("ignore_prepared_report", 1);
      
      const response = await ChartDataApi(formData);
      setState(response.data.message);
    } catch (error) {
      console.error(`Error fetching ${type}:`, error);
    }
  }, [ChartDataApi, selectedComapny]);

  // Data fetching functions
  const fetchData = useCallback((filterState, payload, setCount, doctype = "Sales Order", field = "transaction_date") => {
    const doc = { ...payload, stats_time_interval: filterState.timeInterval };
    const fromDate = filterState.dateFilters.find(f => f.label === "From Date")?.value;
    const toDate = filterState.dateFilters.find(f => f.label === "To Date")?.value;

    const filters = buildFilters(
      doctype,
      field,
      fromDate,
      toDate,
      filterState.statusFilters
    );

    Find_Annual_Sales_Count(doc, filters, setCount, true);
  }, [Find_Annual_Sales_Count, buildFilters]);

  // Effect hooks for data fetching
  
  
  
  useEffect(() => {
    if (!selectedComapny) return;
    fetchData(Sales_Order_to_Deliver_Filters, Sales_Orders_to_Deliver_Count_Payload, setSalesOrderstoDeliverCount);
  }, [Sales_Order_to_Deliver_Filters, selectedComapny, fetchData]);

  useEffect(() => {
    if (!selectedComapny) return;
    fetchData(Sales_Order_to_Bill_Filters, Sales_Order_to_Bill_Count_Payload, setSalesOrderstoBillCount);
  }, [Sales_Order_to_Bill_Filters, selectedComapny, fetchData]);

  useEffect(() => {
    if (!selectedComapny) return;
    fetchData(Active_Customers_Filters, Active_Customer_Count_Payload, setActiveCustomersCount, "Customer", "creation");
  }, [Active_Customers_Filters, selectedComapny, fetchData]);

  useEffect(() => {
    if (!selectedComapny) return; 
    fetchData(Annual_Sales_Filters, Annual_Sales_Count_Payload, setAnnualSalesCount);
  },[Annual_Sales_Filters, selectedComapny, fetchData]);

  useEffect(() => {
    if (!selectedComapny) return;
    ChartApi("Sales Order Trends", SalesOrderTrendsFilters, setsales_order_trends);
  }, [SalesOrderTrendsFilters, selectedComapny, ChartApi]);


  useEffect(() => {
    if (!selectedComapny) return;    
    ChartApi("Delivery Note Trends", DeliveryNoteTrendsFilters, setdelivery_note_trends);
  }, [DeliveryNoteTrendsFilters, selectedComapny, ChartApi]);

  useEffect(() => {
    if (!selectedComapny) return;
    ChartApi("Sales Order Analysis", SalesOrderAnalysisFilters, setsales_order_analysis);
  }, [SalesOrderAnalysisFilters, selectedComapny, ChartApi]);

  useEffect(() => {
    if (!selectedComapny) return;
    ChartApi("Item-wise Sales History", ItemWiseAnnualSalesFilters, setitem_wise_annual_sales);
  }, [ItemWiseAnnualSalesFilters, selectedComapny, ChartApi]);



  // Dashboard cards data
  const dashboardCards = [
    {
      title: "Annual Sales",
      filterType: "Annual_Sales",
      timeInterval:Annual_Sales_Filters.timeInterval,
      value: `₹${formatIndianPrice(AnnualSalesCount.count)}`,
      tooltip: `₹${Number(AnnualSalesCount.count).toLocaleString('en-IN')}`,
      percentage: AnnualSalesCount?.percentage?.toFixed(2) || 0,
      icon: as,
      iconBg: '#fe8d5c'
    },
    {
      title: "Sales Orders to Deliver",
      filterType: "Sales_Order_to_Deliver",
      timeInterval:Sales_Order_to_Deliver_Filters.timeInterval,
      value: SalesOrderstoDeliverCount.count,
      tooltip: SalesOrderstoDeliverCount.count,
      percentage: SalesOrderstoDeliverCount?.percentage?.toFixed(2) || 0,
      icon: Deliver,
      iconBg: '#823455'
    },
    {
      title: "Sales Orders to Bill",
      filterType: "Sales_Order_to_Bill",
      timeInterval:Sales_Order_to_Bill_Filters.timeInterval,
      value: SalesOrderstoBillCount.count,
      tooltip: SalesOrderstoBillCount.count,
      percentage: SalesOrderstoBillCount?.percentage?.toFixed(2) || 0,
      icon: bill,
      iconBg: '#391f84'
    },
    {
      title: "Active Customers",
      filterType: "Active_Customers",
      timeInterval:Active_Customers_Filters.timeInterval,
      value: ActiveCustomersCount.count,
      tooltip: ActiveCustomersCount.count,
      percentage: ActiveCustomersCount?.percentage?.toFixed(2) || 0,
      icon: customer,
      iconBg: '#fe8d5c'
    }
  ];



  console.log("zxcvbnsdfghdfghsdf",sales_order_analysis)
  const charts = [
    {
      type: "Sales_Order_Trends",
      title: "Sales Order Trends",
      component: <ReactLineChart data={sales_order_trends} />,
      fields: ["period", "fiscal_year"]
    },
    {
      type: "Delivery_Note_Trends",
      title: "Top Customers",
      component: <ReactBarChart data={delivery_note_trends} />,
      fields: ["period", "fiscal_year"]
    },
    {
      type: "Sales_Order_Analysis",
      title: "Sales Order Analysis",
      component: <ReactDonutChart data={sales_order_analysis} />,
      fields: ["from_date", "to_date", "status"]
    },
    {
      type: "Item_Wise_Annual_Sales",
      title: "Item-wise Annual Sales",
      component: <ReactBarChart data={item_wise_annual_sales} color={'#391f84'} />,
      fields: ["from_date", "to_date"]
    }
  ];

  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
          <title>Outbound Dashboard</title>
      </Helmet>
      <Header />
      <div className="container-fluid dashboard-container py-0">
                 <Tabs />
        <div className="row dashboard-header py-2" style={{ marginBottom: "0px" }}>
          <div className="col-12">
            <h5 className="mb-0" style={{ color: "#823455" }}>Outbound Dashboard</h5>
          </div>
        </div>

        <div className="row mb-4">
          {dashboardCards.map((card, index) => (
            <div className="col-md-3" key={index}>
              <div className="dashboard_card" style={{ backgroundColor: '#fff' }}>
                <h6 className="dashboard-card-p1 d-flex justify-content-between">
                  <span>{card.title}</span>
                  <span className="threedotsishere" onClick={() => { 
                    setCurrentFilterType(card.filterType); 
                    setShowpopup(true); 
                  }}>
                    <GetIcon iconName="IoFilterSharp" size={15} />
                  </span>
                </h6>
                <p className="dashboard-card-p2 custom-tooltip">
                  {card.value}
                  <span className="tooltip-text">{card.tooltip}</span>
                  <span className="dashboard-icon" style={{ backgroundColor: card.iconBg }}>
                    <img src={card.icon} alt="404" />
                  </span>
                </p>
                <p className="dashboard-card-p3">{card.percentage}% since last {card.timeInterval}</p>
              </div>
            </div>
          ))}
        </div>

        {[0, 2].map((startIdx) => (
          <div className="row mb-4" key={startIdx}>
            {charts.slice(startIdx, startIdx + 2).map((chart) => (
              <div className="col-md-6" key={chart.type}>
                <div className="dashboard-card m-0" style={{ height: "100%" }}>
                  <h5 className="d-flex justify-content-between" style={{ fontSize: "15px", fontWeight: "700" }}>
                    <span>{chart.title}</span>
                    <span 
                      onClick={() => { 
                        setCurrentChartType(chart.type); 
                        setShowChartPopup(true); 
                      }} 
                      style={{ cursor: "pointer" }}
                    >
                      <GetIcon iconName="IoFilterSharp" size={15} />
                    </span>
                  </h5>
                  {chart.component}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      <ChartFilterPopup
        show={showChartPopup}
        onClose={() => setShowChartPopup(false)}
        filters={getCurrentChartFilters()}
        setFilters={(newFilters) => updateFilters(currentChartType, newFilters)}
        fields={charts.find(c => c.type === currentChartType)?.fields || []}
      />

      <CartFilterPopup
        show={showpopup}
        onClose={() => setShowpopup(false)}
        filters={getCurrentFilters()}
        setFilters={(newFilters) => updateFilters(currentFilterType, newFilters)}
        cardType={currentFilterType}
      />

      <Footer /> 
    </div>
  );
};

export default Dashboard;